// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-Product-__ProductPage-module___Main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Product/ProductPage.module.css
// module id = 1187
// module chunks = 1